/** @jsxImportSource @emotion/react */
import { Buttons } from '@zip/business-components';
import { useAuth0 } from 'contexts';
import { FC } from 'react';
import * as styles from './GenericError.styles';

export interface GenericErrorProps {
  heading: string;
  contentLines: string[];
  icon: string;
}

const GenericErrorModule: FC<GenericErrorProps> = ({
  heading,
  contentLines,
  icon,
}) => {
  const { logout } = useAuth0();

  return (
    <>
      <div css={styles.main}>
        <div css={styles.container}>
          <img src={icon} width={96} title="warning" alt="warning" />
          <div className="heading1" css={styles.text}>
            {heading}
          </div>

          {contentLines.map((content, index) => (
            <p className="body2" key={index}>
              {content}
            </p>
          ))}
          <Buttons.Primary
            id="loginButton"
            onClick={(): void => logout()}
            css={styles.loginButton}
          >
            Back to login
          </Buttons.Primary>
        </div>
      </div>
    </>
  );
};

export default GenericErrorModule;
